(() => {
  if (customElements.get('hero-video')) return;

  class HeroVideo extends HTMLElement {
    connectedCallback() {
      const theme = window.theme || {};
      this.videos = Array.from(this.querySelectorAll('video'));
      this.media = this.querySelector('[data-hero-media]');
      this.toggle = this.querySelector('[data-hero-toggle]');
      this.bar = this.closest('.shopify-section')?.querySelector('[data-mobile-bar]') || null;
      this.inView = true;
      const motion = theme.motion ? theme.motion() : 'editorial';
      this.parallax = motion === 'editorial';
      this.userPaused = theme.canAutoplayVideo ? !theme.canAutoplayVideo() : motion === 'off';
      this.ready = document.readyState === 'complete';
      if (!this.ready) {
        this.onLoad = () => {
          this.ready = true;
          this.syncPlayback();
        };
        window.addEventListener('load', this.onLoad, { once: true });
      }

      this.videos.forEach((video) => {
        video.muted = true;
        video.playsInline = true;
      });
      this.toggle?.addEventListener('click', () => {
        this.ready = true;
        this.setPaused(!this.userPaused);
      });
      this.setPaused(this.userPaused);

      if (this.videos.length && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.syncPlayback();
        });
        this.observer.observe(this);
      }

      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.onResize = () => {
        this.syncPlayback();
        this.onScroll();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      document.addEventListener('overlay:change', this.onScroll);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('load', this.onLoad);
      document.removeEventListener('overlay:change', this.onScroll);
      this.observer?.disconnect();
    }

    syncPlayback() {
      const theme = window.theme || {};
      this.videos.forEach((video) => {
        const shown = video.getClientRects().length > 0;
        if (this.userPaused || !this.inView || !shown) {
          video.pause();
          return;
        }
        if (!this.ready) return;
        if (theme.playVideo) {
          theme.playVideo(video);
          return;
        }
        const attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(() => {});
      });
    }

    setPaused(paused) {
      this.userPaused = paused;
      this.syncPlayback();
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-pressed', String(paused));
      this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
    }

    update() {
      const theme = window.theme || {};
      const desktop = theme.isDesktop ? theme.isDesktop() : window.innerWidth >= 1024;
      if (this.media) {
        const y = Math.min(window.scrollY, 1000);
        this.media.style.transform = this.parallax && desktop ? `translateY(${(y * 0.14).toFixed(1)}px)` : '';
      }
      if (this.bar) {
        const overlayOpen = theme.hasOpenOverlay ? theme.hasOpenOverlay() : false;
        const show = !desktop && this.getBoundingClientRect().bottom < 0 && !overlayOpen;
        if (show !== this.barVisible) {
          this.barVisible = show;
          this.bar.classList.toggle('is-visible', show);
          this.bar.inert = !show;
        }
      }
    }
  }

  customElements.define('hero-video', HeroVideo);
})();
